export default __webpack_public_path__ + "static/media/title-topp-fjellforere.7a1c7a03.png";